export default __webpack_public_path__ + "graphics/experience-768@2x.36e0a1ee.jpg";